import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import renderUtils from '../../../helpers/renderUtils';
import LightButton from '../../button/LightButton';

const RadioGroupGeneric = ({
  field,
  formData,
  handleFieldChange,
  options,
  isEnum = false,
}) => {
  if (!options) return <></>;

  const { name, label, enumType, descriptions = [] } = field;

  const [editMode, setEditMode] = useState(false);

  const selectedOption = formData[name];
  const selectedIndex = options.findIndex((opt) =>
    isEnum ? selectedOption === opt : selectedOption?.id === opt.id,
  );
  const hasSelection = selectedIndex !== -1;

  return (
    <>
      {!editMode && hasSelection && (
        <div className="border p-3 mb-3 rounded d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-bold">{label}</div>
            <div className="d-flex align-items-center gap-2 mt-1">
              <span>
                {isEnum
                  ? renderUtils.renderEnumName(selectedOption, enumType)
                  : options.find((o) => o.id === selectedOption?.id)?.name}
              </span>
            </div>
          </div>
          <LightButton onClick={() => setEditMode(true)}>Zmień</LightButton>
        </div>
      )}

      {(editMode || !hasSelection) && (
        <Form.Group className="mb-4">
          {label && <Form.Label className="fw-bold mb-3">{label}</Form.Label>}
          <div className="d-flex flex-column">
            {options.map((option, i) => {
              const isChecked = isEnum
                ? formData[name] === option
                : formData[name]?.id === option.id;

              return (
                <div
                  key={`radio-${name}-${i}`}
                  className="border-bottom py-3 px-2 d-flex justify-content-between align-items-start"
                >
                  <label
                    className="form-check-label me-3 cursor-pointer"
                    htmlFor={`${name}-${i}`}
                    style={{ flex: 1 }}
                  >
                    <div>
                      {isEnum
                        ? renderUtils.renderEnumName(option, enumType)
                        : option.name}
                    </div>
                    {descriptions[i] && (
                      <div className="text-muted small mt-1">
                        {descriptions[i]}
                      </div>
                    )}
                  </label>
                  <input
                    className="form-check-input cursor-pointer"
                    type="radio"
                    name={name}
                    id={`${name}-${i}`}
                    value={isEnum ? option : option.id}
                    style={{
                      width: '1.5em',
                      height: '1.5em',
                      marginTop: '0.35em',
                    }}
                    checked={isChecked}
                    onClick={() => {
                      setEditMode(false);
                      if (!isChecked) {
                        handleFieldChange(option);
                      }
                    }}
                  />
                </div>
              );
            })}
          </div>
        </Form.Group>
      )}
    </>
  );
};

export default RadioGroupGeneric;
